import * as React from 'react';
import { FC } from 'react';
import { Edit, TextField, useTranslate } from 'react-admin';
import { TabbedForm, TextInput, BooleanInput } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { Toolbar, SaveButton } from 'react-admin';
import VersionEdit from './tabs/VersionsTab';
import { SimpleForm } from 'react-admin';

interface Pc {
    id?: string | number;
    title?: string;
    [key: string]: any;
}

interface FieldProps<T = any> {
    record?: T;
    resource?: string;
    basePath?: string;
    [key: string]: any;
}

const useStyles = makeStyles(theme => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
    saveButton: {
        maxWidth: '300px',
    },
    inputGroup: {
        display: 'flex',
        alignItems: 'flex-start',
        '& > *': {
            marginRight: theme.spacing(2),
        },
        width: '100%',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    tabContent: {
        maxWidth: '100%',
    },
}));

const VersionEditToolbar: FC = (props: any) => {
    const classes = useStyles();
    return (
        <Toolbar {...props} className={classes.toolbar}>
            <SaveButton className={classes.saveButton} />
        </Toolbar>
    );
};

const PcTitle: FC<FieldProps<Pc>> = ({ record }) =>
    record ? <TextField source="title" record={record} /> : null;

const SettingsEdit: FC = (props: any) => {
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <Edit title={<PcTitle />} undoable={false} {...props}>
            <SimpleForm toolbar={<VersionEditToolbar />}>
                <VersionEdit />
            </SimpleForm>
        </Edit>
    );
};

export default SettingsEdit;
